import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { ImageRegionTileFragment } from "../../client/generated";
import { assertTypeName } from "../../client/guards";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: ImageRegionTileFragment;
  alternativeTextAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function ImageRegionTile({
  fragment,
  alternativeTextAttributeId,
  children,
  dispatch,
}: Props) {
  const alternativeTextAttribute = fragment.attributes.find(
    (a) => a.id === alternativeTextAttributeId,
  );
  assertTypeName(
    alternativeTextAttribute?.__typename === "AlternativeTextAttribute",
  );

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      preview={alternativeTextAttribute.alternativeText}
      onClick={onClick}
    >
      {children}
    </RegionTile>
  );
}
